import {
  faArrowRight,
  faBookOpen,
  faBookReader,
  faCheckToSlot,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EvaluationSubmission from 'models/EvaluationSubmission';
import React from 'react';
import { EVALUATION_DISPLAY_NAMES } from 'utils/types';
import ItemPanel from 'view/components/common/ItemPanel';
import StatusIcon from 'view/components/common/StatusIcon';

type DisplayMapping = {
  label: string;
  color?: string;
  icon?: IconDefinition;
};

const asgnDisplay: Record<string, DisplayMapping> = {
  wida: { label: 'Multipart', color: 'var(--purple)', icon: faCheckToSlot },
  lexile: { label: 'Multipart', color: 'var(--purple)', icon: faBookReader },
};

interface EvaluationListProps {
  evaluations?: EvaluationSubmission[];
  selected?: EvaluationSubmission;
  onSelect: (evaluation: EvaluationSubmission) => void;
}

const EvaluationList: React.FC<EvaluationListProps> = ({
  evaluations = [],
  selected,
  onSelect,
}) => {
  return (
    <>
      {evaluations.map((sub) => (
        <ItemPanel
          key={`gradebook-entry-${sub.id}`}
          id={`gradebook-entry-${sub.id}`}
          selected={sub === selected}
          onClick={() => onSelect(sub)}
          onDoubleClick={() => onSelect(sub)}
        >
          <div className="row">
            <label className="label-normal">
              {EVALUATION_DISPLAY_NAMES[sub.type]} Evaluation
            </label>
            <StatusIcon
              icon={asgnDisplay[sub.type].icon!}
              color={asgnDisplay[sub.type].color!}
              text={asgnDisplay[sub.type].label}
            />
          </div>
          <div className="row">
            <StatusIcon
              icon={faBookOpen}
              color={'var(--dark-green)'}
              text={'Open'}
            />
            {sub === selected && (
              <>
                {'Select'}
                <FontAwesomeIcon icon={faArrowRight} size="xl" />
              </>
            )}
          </div>
        </ItemPanel>
      ))}
    </>
  );
};

export default EvaluationList;
